import { MSSub } from "./subscription";  

const GET_BACNET = "/Methods/GetBacnetSchedules";
  
type IItemTaskId = {
  itemId: number;
  taskId: number;
};

type ISchedular = {
  id: string;
  name: string;
  ExceptionInput: IItemTaskId;
  ExceptionOutput: IItemTaskId;
  WeeklyScheduleInput: IItemTaskId;
  WeeklyScheduleOutput: IItemTaskId;
};

export class MSCalendarApi extends MSSub {
  constructor() {
    super();
  }

  async GetBacnetSchedules(itemId : number, path : string): Promise<{
    code: number;
    schedules: Array<ISchedular>;
  }> {
    try {
      const res = await this.req.post(GET_BACNET, {
          sessionId: this.sessionId,
          itemId: itemId,
          path: path
      });
      return res.data;
    } catch (e) {
      console.log("Error in GetBacnetSchedules ", e);
    }
  } 
}
